import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { Lock, ShieldCheck } from "lucide-react";

const ACK_KEY = "bizarre_confidential_ack";

export default function ConfidentialNotice() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(ACK_KEY)) return;
    api.get("/settings").then(({ data }) => {
      if (data.confidential_notice) setOpen(true);
    }).catch(() => {});
  }, []);

  const ack = () => { localStorage.setItem(ACK_KEY, "1"); setOpen(false); };

  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] flex items-center justify-center p-6"
          style={{ background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)" }}>
          <motion.div initial={{ scale: 0.92, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.92, opacity: 0 }}
            transition={{ ease: [0.22, 1, 0.36, 1] }}
            data-testid="confidential-modal"
            className="w-full max-w-md card-surface p-8 noise text-center border-gold/30">
            <div className="w-14 h-14 rounded-2xl bg-gold/15 border border-gold/30 flex items-center justify-center mx-auto mb-5">
              <Lock size={26} className="text-gold" />
            </div>
            <div className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-[0.2em] mb-3">
              <ShieldCheck size={14} /> {t("confidential.badge")}
            </div>
            <h2 className="font-display text-2xl mb-3">{t("confidential.title")}</h2>
            <p className="text-white/55 text-sm leading-relaxed mb-6">
              {t("confidential.body")}
            </p>
            <button data-testid="confidential-ack" onClick={ack}
              className="w-full gold-gradient text-black rounded-full py-3 font-medium hover:opacity-90 transition-opacity">
              {t("confidential.ack")}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
